export function Brand() {
  return (
    <span className="brand">
      <span className="brand-mark" aria-hidden>
        <svg viewBox="0 0 32 32" width="28" height="28">
          <rect x="2" y="2" width="28" height="28" rx="8" fill="#1e6cff" />
          <path
            d="M9 10h14M9 16h14M9 22h9"
            stroke="#fff"
            strokeWidth="3"
            strokeLinecap="round"
          />
        </svg>
      </span>
      <span className="brand-text">
        <strong>Integrella</strong> Benchmark <span className="brand-divider">·</span> Dojo
      </span>
    </span>
  );
}
